<template>
    <div class="over-hide round-5" style="position: relative" :style="{width,height}">
        <div :id="id" :style="{width,height}"></div>
        <myNodataVchart v-if="rows.length == 0"></myNodataVchart>
    </div>
</template>

<script>
    import myNodataVchart from './myNodataVchart'
    export default {
        name: "myEcharsLine",
        components:{
            myNodataVchart
        },
        props:{
            id:{
                default: 'echart-line',
                type:String
            },
            rows: {
                default: () => [],
                type: Array
            },
            width:{
                default: '100%',
                type: String
            },
            height:{
                default: '300px',
                type:String
            },
            value_key:{
                type:String
            },
            name_key:{
                type:String
            },
            color: {
                default: () => [
                    '#0081ff'
                ],
                type: Array
            },
            text_color:{
                default: 'black',
                type:String
            },
        },
        data:function(){
            return{
                myChart:null
            }
        },
        mounted:function(){
        },
        methods: {
        },
        beforeDestroy: function () {
            if(this.myChart){
                this.myChart.dispose();
            }
        },
        watch:{
            rows(newVal){
                var chartDom = document.getElementById(this.id);
                this.myChart = this.$echarts.init(chartDom);

                if(newVal.length > 0){
                    this.myChart.showLoading();
                    var option;

                    option = {
                        color: this.color,
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: [],
                            axisLabel: {
                                rotate:30,
                                textStyle: {
                                    color: this.text_color // x轴标签文字颜色
                                }
                            },
                        },
                        yAxis: {
                            type: 'value',
                            axisLabel: {
                                textStyle: {
                                    color: this.text_color // y轴标签文字颜色
                                }
                            },
                        },
                        grid:{
                            left:80,
                            right:50
                        },
                        series: [{
                            data: [],
                            type: 'line',
                            smooth: true,
                            areaStyle: {}
                        }]
                    };

                    newVal.forEach((item)=>{
                        option.xAxis.data.push(item[this.name_key]);
                        option.series[0].data.push(item[this.value_key]);
                    });

                    this.myChart.setOption(option);
                    this.myChart.hideLoading();
                }
                else{
                    this.myChart.clear();
                }
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myEcharsLine.vue